<form [formGroup]="form" [ngxsForm]="formPath" autocomplete="off">
  <ng-container formArrayName="fromSystemMaterials">
    <table mat-table matSort [dataSource]="dataSource">
      <ng-container matColumnDef="select">
        <th class="w-5" mat-header-cell *matHeaderCellDef mat-sort-header>
          Select
        </th>
        <td class="w-5" mat-cell *matCellDef="let e; let i = index">
          <div
            [formGroupName]="i"
            *ngIf="!e.isAssociated; else alreadyAssociatedBlock"
          >
            <mat-checkbox
              class="md-field"
              appearance="outline"
              color="primary"
              matInput
              formControlName="selected"
              (click)="$event.preventDefault()"
            ></mat-checkbox>
          </div>
          <ng-template #alreadyAssociatedBlock>
            <div>Assoc</div>
          </ng-template>
        </td>
      </ng-container>
      <ng-container matColumnDef="submittedBy">
        <th class="w-8" mat-header-cell *matHeaderCellDef mat-sort-header>
          Submitted by
        </th>
        <td class="w-8" mat-cell *matCellDef="let e">{{ e?.submittedBy }}</td>
      </ng-container>

      <ng-container matColumnDef="materialType">
        <th class="w-12" mat-header-cell *matHeaderCellDef mat-sort-header>
          Material type
        </th>
        <td class="w-12" mat-cell *matCellDef="let e">{{ e?.materialType }}</td>
      </ng-container>

      <ng-container matColumnDef="dateFiled">
        <th class="w-8" mat-header-cell *matHeaderCellDef mat-sort-header>
          Date filed
        </th>
        <td class="w-8" mat-cell *matCellDef="let e">
          {{ e?.dateFiled ? (e?.dateFiled | date: 'mediumDate') : '--' }}
        </td>
      </ng-container>

      <ng-container matColumnDef="fileName">
        <th
          class="w-20 mw-20"
          mat-header-cell
          *matHeaderCellDef
          mat-sort-header
        >
          File name
        </th>
        <td class="w-20 mw-20" mat-cell *matCellDef="let e; let i = index">
          <div class="file-name">
            <a
              (click)="$event.stopPropagation()"
              [routerLink]=""
              (click)="onOpenFile(e)"
              >{{ e?.document?.name }}</a
            >
          </div>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr
        mat-row
        *matRowDef="let e; columns: displayedColumns; let i = index"
        (click)="onRowClick(e, i)"
      ></tr>
    </table>

    <div
      *ngIf="tableData?.length <= 0"
      fxLayoutAlign="center center"
      fxLayout="column"
      class="mt-20"
    >
      <p>
        There are no documents in the system related to this matter. Please
        upload your filed and supporting materials from your device
      </p>
      <button mat-flat-button color="primary" (click)="onSelectUploadTab()">
        Get started
        <mat-icon style="margin-left: 5px">arrow_forward</mat-icon>
      </button>
    </div>
  </ng-container>
</form>
